<div class="dropdown" (clickOutside)="close($event)" [openState]="isShowing">
  <div class="dropdown__header" (focusin)="open($event)" (click)="toggle()">
    <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
    @if (!headerTemplate) {
      <div class="dropdown__title" tabIndex="0">
        <span>{{ title }}</span
        ><ftr-icon align="Middle" [icon]="'ArrowDropDown'"></ftr-icon>
      </div>
    }
  </div>
  @if (isShowing) {
    <div [ngClass]="{ dropdown__body: true, 'dropdown__body--anchor-bottom-left': true }" (click)="handleBodyClick()">
      <ng-content></ng-content>
    </div>
  }
</div>
